// AUTO-GENERATED by tools/design-tokens/generate-css-refs.ts -- do not edit.
// Regenerate: npm run generate:derived-artifacts (or any typecheck/vitest run -- both ensure it)

/** Typography tokens */
export const typography = {
	fontFamily: {
		sans: "var(--font-family-sans)",
		mono: "var(--font-family-mono)",
	},
	fontWeight: {
		light: "var(--font-weight-light)",
		normal: "var(--font-weight-normal)",
		regular: "var(--font-weight-regular)",
		medium: "var(--font-weight-medium)",
		semibold: "var(--font-weight-semibold)",
		bold: "var(--font-weight-bold)",
		extrabold: "var(--font-weight-extrabold)",
		black: "var(--font-weight-black)",
	},
	fontSize: {
		"2xs": "var(--font-size-2xs)",
		xs: "var(--font-size-xs)",
		sm: "var(--font-size-sm)",
		base: "var(--font-size-base)",
		lg: "var(--font-size-lg)",
		xl: "var(--font-size-xl)",
		"2xl": "var(--font-size-2xl)",
		"3xl": "var(--font-size-3xl)",
		"4xl": "var(--font-size-4xl)",
		"5xl": "var(--font-size-5xl)",
		"6xl": "var(--font-size-6xl)",
		"7xl": "var(--font-size-7xl)",
		"8xl": "var(--font-size-8xl)",
	},
	lineHeight: {
		none: "var(--line-height-none)",
		snug: "var(--line-height-snug)",
		tight: "var(--line-height-tight)",
		normal: "var(--line-height-normal)",
		"default": "var(--line-height-default)",
		relaxed: "var(--line-height-relaxed)",
	},
	letterSpacing: {
		hero: "var(--letter-spacing-hero)",
		primary: "var(--letter-spacing-primary)",
		tight: "var(--letter-spacing-tight)",
		normal: "var(--letter-spacing-normal)",
		tertiary: "var(--letter-spacing-tertiary)",
		wide: "var(--letter-spacing-wide)",
		uppercase: "var(--letter-spacing-uppercase)",
		widest: "var(--letter-spacing-widest)",
	},
	hierarchy: {
		hero: {
			size: "var(--type-hierarchy-hero-size)",
			weight: "var(--type-hierarchy-hero-weight)",
			lineHeight: "var(--type-hierarchy-hero-line-height)",
			letterSpacing: "var(--type-hierarchy-hero-letter-spacing)",
			asideSize: "var(--type-hierarchy-hero-aside-size)",
		},
		primary: {
			size: "var(--type-hierarchy-primary-size)",
			weight: "var(--type-hierarchy-primary-weight)",
			lineHeight: "var(--type-hierarchy-primary-line-height)",
			letterSpacing: "var(--type-hierarchy-primary-letter-spacing)",
		},
		secondary: {
			size: "var(--type-hierarchy-secondary-size)",
			weight: "var(--type-hierarchy-secondary-weight)",
			lineHeight: "var(--type-hierarchy-secondary-line-height)",
			letterSpacing: "var(--type-hierarchy-secondary-letter-spacing)",
		},
		tertiary: {
			size: "var(--type-hierarchy-tertiary-size)",
			weight: "var(--type-hierarchy-tertiary-weight)",
			lineHeight: "var(--type-hierarchy-tertiary-line-height)",
			letterSpacing: "var(--type-hierarchy-tertiary-letter-spacing)",
		},
	},
	semanticWeights: {
		action: "var(--type-semantic-weight-action)",
		header: "var(--type-semantic-weight-header)",
		body: "var(--type-semantic-weight-body)",
	},
	body: {
		fontSize: "var(--type-body-font-size)",
		fontWeight: "var(--type-body-font-weight)",
		lineHeight: "var(--type-body-line-height)",
		letterSpacing: "var(--type-body-letter-spacing)",
	},
	label: {
		fontSize: "var(--type-label-font-size)",
		fontWeight: "var(--type-label-font-weight)",
		lineHeight: "var(--type-label-line-height)",
		letterSpacing: "var(--type-label-letter-spacing)",
	},
	caption: {
		fontSize: "var(--type-caption-font-size)",
		fontWeight: "var(--type-caption-font-weight)",
		lineHeight: "var(--type-caption-line-height)",
		letterSpacing: "var(--type-caption-letter-spacing)",
	},
} as const;

/** Pre-joined font family strings */
export const fontFamilyCSS = {
	sans: "var(--font-family-sans)",
	mono: "var(--font-family-mono)",
} as const;
